import { useMutation } from "@apollo/client/react";
import { SEND_LG } from "../../mutations/invoices/sendLg";
import GET_INVOICE_DELIVERY_APPROVALS from "../../queries/invoices/getInvoiceDeliveryApprovals";

export interface SendLgInput {
  content: string;
  invoiceIds: string[];
  recipientEmail: string;
}

export interface SendLgResponse {
  invoice: {
    sendLg: { success: boolean };
  };
}

export const useSendLg = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: SendLgResponse) => void;
  onError: () => void;
}) => {
  const [sendLg, { data, loading, error }] = useMutation<SendLgResponse>(
    SEND_LG,
    {
      onCompleted,
      onError,
      refetchQueries: [
        "getClientAssessmentInvoices",
        GET_INVOICE_DELIVERY_APPROVALS,
      ],
      awaitRefetchQueries: true,
    },
  );

  return { sendLg, data, loading, error };
};
